export const TopToolsIconsMap = {
  track_order: 'IconLocationPinStroke',
  report_issue: 'IconShippingTruck',
  purchase_history: 'IconBinoculars',
  find_nearest_store: 'IconStorefront',
  start_online_return: 'IconMail',
  learn_how: 'IconShippingPrep',
}